var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},_vm._l((_vm.agreementList),function(item,index){return _c('div',{key:index,staticClass:"agreement-item flex",on:{"click":function($event){return _vm.itemclick(item)}}},[_c('div',[_vm._v(_vm._s(item.agreementName))]),_c('van-icon',{attrs:{"name":"arrow","size":"0.38rem","color":"#ccc"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }